import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "editor"]

  connect() {
    this.editorTarget.innerHTML = this.inputTarget.value || "<p></p>"
  }

  sync() {
    this.inputTarget.value = this.editorTarget.innerHTML
  }

  format(event) {
    event.preventDefault()
    const command = event.currentTarget.dataset.command
    if (!command) return

    document.execCommand(command, false)
    this.sync()
  }
}
